import { getGeocode, getLatLng } from "use-places-autocomplete";
import { getVenueListWithLocationAndType } from "src/redux/slices/venueSlice";
import { getVenueListforReservation } from "src/redux/slices/venueSlice";
import { resetVenueIdtoBlock } from "src/redux/slices/VenueLocationModalSlice";

export async function selectedVenue(dispatch, type, val) {
  try {
    const address = localStorage.getItem("address");
    const results = await getGeocode({ address });
    const { lat, lng } = await getLatLng(results[0]);
    const location = `${lat},${lng}`;
    const partySize = 2;
    const dateISO = () => {
      const date = new Date();
      const offset = date.getTimezoneOffset();
      date.setMinutes(date.getMinutes() - offset);
      return date.toISOString();
    };

    const generateTimeSlots = (date) => {
      const slots = [];
      const now = new Date();
      const selectedDay = new Date(date).setHours(0, 0, 0, 0);
      const today = new Date().setHours(0, 0, 0, 0);

      let start = selectedDay === today
        ? Math.ceil((now.getHours() * 60 + now.getMinutes()) / 30) * 30
        : 0;

      let end = 24 * 60;

      while (start < end) {
        let hours = Math.floor(start / 60);
        let minutes = start % 60;
        let paddedHours = hours < 10 ? `0${hours}` : `${hours}`;
        let formattedMinutes = minutes === 0 ? "00" : minutes.toString().padStart(2, '0');
        slots.push(`${paddedHours}:${formattedMinutes}`);
        start += 30;
      }

      return slots[0];
    };

    let currentDate = new Date(dateISO());
    let newTime = generateTimeSlots(dateISO()).split(":");
    currentDate.setHours(newTime[0])
    currentDate.setMinutes(newTime[1].split(" ")[0])

    if (type == "reservation") {
      localStorage.setItem("isReservation", 'true');
      await dispatch(getVenueListforReservation(location, partySize, currentDate));
    } else {
      localStorage.setItem("isReservation", 'false');
      if (type === "QrDineIn") {
        localStorage.setItem("mode", "QrDineIn");
      } else if (type === "QrPickUp") {
        localStorage.setItem("mode", "QrPickUp");
      } else if (type === "carHop") {
        localStorage.setItem("mode", "carHop");
      } else if (type == "dineIn") {
        dispatch(resetVenueIdtoBlock())
        localStorage.setItem("mode", "dineIn");
      } else {
        dispatch(resetVenueIdtoBlock())
        localStorage.setItem("mode", "pickUp");
      }
      localStorage.setItem("address", results[0]?.formatted_address);
      const venueType = (type === "QrDineIn" || type === "dineIn") ? "isDineIn" : "isPickUp";
      await dispatch(getVenueListWithLocationAndType(location, venueType, val));
    }
  } catch (error) {
    console.log("Error ", error);
  }
}
